import React from "react";
import { withRouter } from "react-router";

const styles = {
  fullWidthStyle: {
    width: "100%",
    textAlign: "center"
  }
};

const DataSource = props => {
  const { pathname } = props.router.location;
  const explanation = pathname.startsWith("/ptab") ? (
    "PTAB data is always up-to-date with USPTO PTAB OPEN API."
  ) : pathname.startsWith("/prosecution") ? (
    "Prosecution data is aggregated from USPTO Patent Examination Data System, and is updated weekly. Law firms are extracted from USPTO office actions data."
  ) : pathname.startsWith("/patents/prior-art/pqai") ? (
    <span>
      Prior Art is provided by <a href="https://projectpq.ai/">PQAI</a>
    </span>
  ) : pathname.startsWith("/patents") || pathname.startsWith("/patents") || pathname.startsWith("/standards/opal/") ? (
    "Patent data is provided by IFI Claims, and is updated weekly."
  ) : pathname.startsWith("/litigation") ? (
    "Litigation data is provided by MaxVal (LexisNexis) Litigation Databank, and is updated daily."
  ) : pathname.startsWith("/exparte") ? (
    "Ex-Parte Reexamination data is aggregated from USPTO Patent Examination Data System, and is updated daily."
  ) : pathname.startsWith("/standards/open/") ? (
    "Document repository for each standard is aggregated from the corresponding working group, and is updated monthly."
  ) : (
    ""
  );
  return explanation ? (
    <p style={styles.fullWidthStyle}>
      <small>{explanation}</small>
    </p>
  ) : null;
};

export default withRouter(DataSource);
